// ~/plugins/sw.client.ts
export default defineNuxtPlugin(() => {
  if (process.client && 'serviceWorker' in navigator) {
    //console.log('Service Worker plugin loaded');
    
    // Check if page is already loaded
    if (document.readyState === 'complete') {
     // console.log('Page already loaded, registering SW immediately');
      registerServiceWorker();
    } else {
      console.log('Waiting for page load event');
      window.addEventListener('load', () => {
        console.log('Page load event fired, registering SW');
        registerServiceWorker();
      });
    }
    
    async function registerServiceWorker() {
      try {
       // console.log('Starting SW registration...');
        
        // First check if SW file exists
        const swResponse = await fetch('/sw.js');
        //console.log('SW file check:', swResponse.status, swResponse.statusText);
        
        if (!swResponse.ok) {
          throw new Error(`Service worker file not found: ${swResponse.status}`);
        }
        
        const registration = await navigator.serviceWorker.register('/sw.js', { 
          scope: '/' 
        });
        
        console.log('SW registered successfully:', {
          scope: registration.scope,
          active: registration.active?.state,
          installing: registration.installing?.state,
          waiting: registration.waiting?.state
        });
        
      } catch (error) {
        console.error('SW registration failed:', error);
      }
    }
  } else {
    console.log('Service Worker not supported or not on client');
  }
});